import logo from './logo.svg';
import {useEffect,useState} from 'react';
import Recipes from './Recipes'
import hat from './hat2.png'
import './App.css';
import Tilt from 'react-tilt'

function App() {
  const appid = "b79b407e";
  const key = "14df885f2eede2a54ba95a85c91ef0c8";
  const [recipes,setReceps] = useState([]);
  const[search,setSearch] = useState("");
  const [query,setQuery] = useState("");
  useEffect(()=>{
    getRecepie();
  },[query])

  const getRecepie =async () =>{
    const response = await fetch(`https://api.edamam.com/search?q=${query}&app_id=${appid}&app_key=${key}`);
    const data = await response.json();
    setReceps(data.hits);
    console.log(data.hits);
  }
  const updateSearch = e =>{
    setSearch(e.target.value);
  }
  const getSearch = e =>{
    e.preventDefault();
    setQuery(search);

  }
  return (
    <div className="App">
        <Tilt className="Tilt" options={{ max : 45 }} style={{ height: 250, width: 250 }} >
            <div className="Tilt-outer">
              <img className = 'img' src="https://lirp-cdn.multiscreensite.com/0ad506f2/dms3rep/multi/opt/FoodiesLocalGuides_Logo_Large_Red-640w.png"></img>
            </div>
        </Tilt>
        <form onSubmit={getSearch} className="search-form">
        <input className="search-bar" type="text" placeholder="Search recipe" value={search} onChange = {updateSearch}/>
        <button className="search-button" type="submit">SEARCH</button>
      </form>
      <div className="cont">
      {recipes.map(recipe=>(
        <Recipes
        key={recipe.recipe.label} 
        name={recipe.recipe.label} 
        image={recipe.recipe.image} 
        cal={recipe.recipe.calories}
        tag={recipe.recipe.dietLabels[0]}
        ingredients={recipe.recipe.ingredients}
        />
      ))}
      </div>
    </div>
  );
}

export default App;
